export default "__VITE_ASSET__CGBFEgUD__"